<template>
    <div
        class="field"
        :class="{
            'has-error': hasError,
        }"
    >
        <div class="control is-clearfix has-icons-left">
            <span class="icon is-left"
                ><svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="phone"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    class="svg-inline--fa fa-phone fa-w-16"
                >
                    <path
                        fill="currentColor"
                        d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                        class=""
                    ></path></svg
            ></span>
            <input type="tel" class="input" v-model="editData" @input="maskPhoneNumber" />
        </div>
    </div>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { AsYouType } from 'libphonenumber-js';

export default {
    name: 'PhoneForm',
    components: {},
    props: ['value', 'v', 'country'],
    data() {
        return {
            editData: null,
        };
    },
    watch: {
        value() {
            this.handleValue();
        },
    },
    computed: {
        hasError() {
            return this.v.$error;
        },
        calllink() {
            const phoneNumber = parsePhoneNumberFromString(String(this.editData), this.country);
            if (phoneNumber) {
                return phoneNumber.format('RFC3966');
            } else {
                return false;
            }
        },
    },
    methods: {
        maskPhoneNumber(event) {
            const asYouType = new AsYouType(this.country);
            asYouType.input(this.editData);
            var phone = asYouType.getNumber();
            if (phone) {
                this.editData = phone.formatInternational();
                this.isValid = phone.isValid();
            }
            event.target.value = this.editData;
            this.updateValue(event);
        },
        /*
        isValid_PhoneNumber() {
            let valid = false;

            const phoneNumber = parsePhoneNumberFromString(this.editData);
            if (phoneNumber) {
                valid = phoneNumber.isValid();
            }

            return valid;
        },*/
        handleValue() {
            if (this.value) {
                this.editData = JSON.parse(JSON.stringify(this.value));
            } else {
                this.editData = '';
            }
        },
        updateValue(event) {
            this.$emit('input', event);
        },
    },
    created() {
        this.handleValue();
    },
};
</script>
